import { combineReducers } from '@reduxjs/toolkit';

import persistedLocaleReducer from './persistedLocale/slice';
import permissionsUiReducer from './permissionsUi/slice';

import storeLocaleReducer from '../storeLocale/slice';

const persisted = combineReducers({
    persistedLocale: persistedLocaleReducer,
    storeLocale: storeLocaleReducer,
    permissionsUi: permissionsUiReducer,
});

export default persisted;